import {FC, useCallback, useState} from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import {ListItemText} from "../Menu.tsx";
import ListItemButton from "@mui/material/ListItemButton";
import Modal from "./Subscription/Modal.tsx";
import {Plan} from "@memaro/api";

export type SubscriptionButtonProps = {
    profileID: string;
    availablePlans: Plan[];
    onClick?: () => void;
}

const SubscriptionButton: FC<SubscriptionButtonProps> = ({profileID, availablePlans, onClick}) => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false)

    const handleDialogOpen = useCallback(() => {
        setDialogOpen(true)
        onClick?.()
    }, [onClick])
    const handleDialogClose = useCallback(() => setDialogOpen(false), [])

    return (
        <>
            <ListItem disablePadding>
                <ListItemButton onClick={handleDialogOpen}>
                    <ListItemIcon>
                        <ShoppingCartIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Pagina activeren"/>
                </ListItemButton>
            </ListItem>
            <Modal
                open={dialogOpen}
                profileID={profileID}
                availablePlans={availablePlans}
                onClose={handleDialogClose}
            />
        </>
    )
}

export default SubscriptionButton
